import React, { useState, useEffect } from 'react';
// components
import Table from '../../components/Table';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';

import versionData from '../../../src/json/project-info.json';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'material-design-icons/iconfont/material-icons.css';
import '../../../src/assets/scss/custom/components/_alert.scss';
import '../dashboard/Dashboard/Dashboard.css';
import { sizePerPageList, versionHistoryColumns } from '../../utils/ColumnUtils';

const VersionHistory = () => {
    const { auth } = useSelector((state) => ({
        auth: state.Auth,
    }));

    const userRole = auth?.user?.role;

    const [data, setData] = useState([]);
    const [limit, setLimit] = useState(5);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [statusMessage, setStatusMessage] = useState('');

    useEffect(() => {
        const formattedData = versionData.versions.map((item, index) => ({
            id: index + 1,
            module: item.module,
            version: item.version,
            date: item.date,
            changes: item.changes,
        }));

        setTotalCount(formattedData.length);
        setPageCount(Math.ceil(formattedData.length / limit));

        // Important Part
        const startIndex = (pageNumber - 1) * limit;
        const endIndex = startIndex + limit;

        const paginatedData = formattedData.slice(startIndex, endIndex);

        setData(paginatedData);
    }, [limit, pageNumber]); // pageNumber bhi add karo

    //pagination
    const handlePageChange = async (value) => {
        setPageNumber(1);
        setLimit(value);
    };

    const handlePageClick = async (value) => {
        setPageNumber(value);
    };

    return (
        <>
            <ToastContainer />

            <div className=" py-1 " style={{ width: '100%' }}>
                {/* <div className="container-fluid px-0">
                    <div className="row align-items-center gx-2 gy-2">
                      
                        <div className="col-12 col-md-auto">
                            <button className="btn_1 w-100" style={{ marginLeft: '0' }}>
                                Version History
                            </button>
                        </div>
                    </div>
                </div> */}

                <div className="container-fluid px-0">
                    <div className="row align-items-center gx-2 gy-2">
                        <div className="col-12 col-md-auto">
                            <h5
                                className="fw-bold mb-1"
                                style={{
                                    fontFamily: "'Poppins', sans-serif",
                                    color: '#000',
                                    paddingLeft: '10px',
                                }}>
                                Version History
                            </h5>
                        </div>
                    </div>
                </div>

                <div
                    className="col-sm-12 card-alerts my-2 p-2 border-0  text-start no-radius"
                    style={{ width: '100%', position: 'relative' }}>
                    <Table
                        columns={versionHistoryColumns()}
                        data={data}
                        pageSize={limit}
                        pageCount={pageCount}
                        pageNumber={pageNumber}
                        totalCount={totalCount}
                        sizePerPageList={sizePerPageList}
                        isSortable={true}
                        pagination={true}
                        isSearchable={true}
                        onPageChange={handlePageChange}
                        onPageClick={handlePageClick}
                    />
                </div>
            </div>

            <div className="modal fade" id="statusModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button
                                type="button"
                                className="btn-close ms-auto"
                                data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                        <div className="modal-body text-center">
                            <img
                                src="/asset-images/checkmark.png"
                                alt="Success"
                                className="img-fluid"
                                style={{ maxWidth: '100px' }}
                            />
                            <p className="mt-2">{statusMessage}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default VersionHistory;
